module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_1-b7d0cbd565612d45bf68f85d2002eb6e.jpeg";